import { render } from "./ListSurcharges.vue?vue&type=template&id=00d461f1&scoped=true&ts=true"
import script from "./ListSurcharges.vue?vue&type=script&lang=ts"
export * from "./ListSurcharges.vue?vue&type=script&lang=ts"

import "./ListSurcharges.vue?vue&type=style&index=0&id=00d461f1&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d461f1"]])

export default __exports__